import { FEATURE_FLAGS } from '@constants/feature';
import { MetaIntegrationProvider } from '@features/lead-management/components/lead-settings/types';

export const leadsTableColumn = [
  { Header: 'Customer Name', accessor: 'customerName', width: '13%' },
  { Header: 'Mobile Number', accessor: 'mobileNumber', width: '10%' },
  { Header: 'Tags', accessor: 'tags', width: '15%' },
  { Header: 'Source', accessor: 'source', width: '10%' },
  { Header: 'Assignee', accessor: 'assignee', width: '16%' },
  { Header: 'Status', accessor: 'status', width: '16%' },
  { Header: 'Actions', accessor: 'actions', width: '8%' }
];

export type AddLeadOption = {
  id: string;
  value: string;
  label: string;
  iconName: string;
  requiredFeatureFlag?: (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
  isDisabled?: boolean;
  disabledTooltip?: string;
  getOverrides?: (metaProvider: MetaIntegrationProvider | null) => {
    isDisabled: boolean;
    disabledTooltip: string;
  } | null;
};

export const addLeadOptions: AddLeadOption[] = [
  {
    id: '1',
    value: 'add-manually',
    label: 'Add Manually',
    iconName: 'add-user-dark'
  },
  {
    id: '2',
    value: 'import-csv',
    label: 'Import CSV/Excel',
    iconName: 'file-upload-dark'
  },
  {
    id: '3',
    value: 'sync-from-meta',
    label: 'Sync from Meta',
    iconName: 'sync-from-meta',
    requiredFeatureFlag: FEATURE_FLAGS.META_LEAD_INGESTION,
    getOverrides: (metaProvider) =>
      metaProvider?.is_active === false
        ? {
            isDisabled: true,
            disabledTooltip:
              'Lead sync is disabled in Settings. Turn it on to sync now'
          }
        : null
  }
];

export const getAddLeadOptionsForOrg = (
  enabledFlags: string[] | undefined,
  metaProvider?: MetaIntegrationProvider | null
): AddLeadOption[] => {
  const enabledFlagSet = enabledFlags ? new Set(enabledFlags) : undefined;
  return addLeadOptions.reduce<AddLeadOption[]>((result, option) => {
    if (
      option.requiredFeatureFlag &&
      !enabledFlagSet?.has(option.requiredFeatureFlag)
    ) {
      return result;
    }
    const overrides = option.getOverrides?.(metaProvider ?? null);
    result.push(overrides ? { ...option, ...overrides } : option);
    return result;
  }, []);
};

export const fieldOptions = {
  status: {
    id: 1,
    label: 'Status',
    field: 'status'
  },
  source: {
    id: 2,
    label: 'Source',
    field: 'source'
  },
  tags: {
    id: 3,
    label: 'Tags',
    field: 'tags'
  },
  assignee: {
    id: 4,
    label: 'Assignee',
    field: 'assignee'
  },
  dateRange: {
    id: 5,
    label: 'Lead Creation Date',
    field: 'dateRange'
  }
};

export type CustomField = {
  key: string;
  value: any;
};
